import moment from "moment";
import { RepairShop } from "../../../../model/RepairShop";

moment.updateLocale("ko", {
  week: {
    dow: 0,
    doy: 4,
  },
});

/**
 * 요일 데이터
 */
export const DAY = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};
export type DayType = keyof typeof DAY; // 요일 데이터 타입

/**
 * enum 에서 key 값 얻기
 * @param value
 * @returns
 */
export const getKeyEnum = <T>(value: string | number, obj: T) =>
  Object.entries(obj as any).find(([k, v]) => v === value)?.[0];

/**
 * enum 에서 key 값 얻기
 * @param key
 * @returns
 */
export const getValueEnum = <T>(key: string, obj: T) => (obj as any)[key];

export const dateParsing = (repairShop: RepairShop) => {};

/**
 * 현재 주차 구하기
 * @TODO 격주 등 버그 있을 듯 (이건 locale 상 어쩔 수없음..)
 * @param m
 * @returns
 */
export const weekOfMonth = (m: moment.Moment) => {
  moment.updateLocale("ko", {
    week: {
      dow: 0,
      doy: 12,
    },
  });

  const addWeeks = moment(m).startOf("month").day() === 0 ? 1 : 0;

  return m.week() - moment(m).startOf("month").week() + addWeeks;
};

/**
 * 해당달 첫번째 주차
 * @param m
 * @returns
 */
export const firstWeekOfMonth = (m: moment.Moment) => m.startOf("month").week();
/**
 *
 * @param m 해당 달 마지막 주차
 * @returns
 */
export const endWeekOfMonth = (m: moment.Moment) => m.endOf("month").week();

/**
 * times parsing
 */
export * from "./parsing";
